import { Navigate, useParams } from 'react-router-dom';
import { useAuthStore } from '@/lib/stores/auth';

/**
 * 书签兼容重定向：personal-page 特性将原先的 dashboard 子路由
 * （`dashboard/following`、`dashboard/favorites`、`dashboard/provider/followers`）
 * 迁移到了 `/:locale/users/:id/<section>`。这里保留旧路径作为重定向入口，
 * 让老书签继续可用，自动跳转到当前登录用户的个人主页对应分区。
 *
 * 未登录时跳到 login 页（与全站其它受保护页面的 `?redirect=` 约定一致）。
 */
export function ProfileRedirect({
  section,
}: {
  section: 'following' | 'favorites' | 'followers' | 'settings' | 'notifications';
}) {
  const { locale } = useParams<{ locale: string }>();
  const loc = locale || 'en';
  const user = useAuthStore((s) => s.user);

  if (!user) {
    return <Navigate to={`/${loc}/login`} replace />;
  }
  return <Navigate to={`/${loc}/users/${user.id}/${section}`} replace />;
}
